import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useModal } from "@ebay/nice-modal-react";
import BaseModal from "components/foundation/modal/BaseModal";
import MaintenanceNotice from "features/TopUp/view/modal/MaintenanceNotice";

const MaintenanceGuard = ({ maintenanceOrder, children }: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  const modal = useModal(BaseModal);

  const handledRef = useRef(false);

  useEffect(() => {
    const path = location.pathname.replace(/^\//, ""); 

    const segments = path.split("/");
    const routeCode = `${segments[0]}/${segments[1]}`;

    const match = maintenanceOrder?.find(
      (item: any) =>
        item.code === routeCode && item.isMaintenance === true
    );

    if (!match) {
      handledRef.current = false;
      return;
    }

    if (handledRef.current) return;
    handledRef.current = true;

    modal
      .show({
        children: <MaintenanceNotice />,
      })
      .catch(() => {});

    setTimeout(() => {
      navigate("/", { replace: true });
    }, 0);
  }, [maintenanceOrder, location.pathname]);

  return children;
};

export default MaintenanceGuard;